import { Grid, IconButton } from '@mui/material';
import classNames from 'classnames';
import { memo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { AirportConfiguration, AirportConfigurationType, ResourceType } from '../../../backend';
import { StyledAddIcon, StyledMenuResourceItem, StyledPropertiesBox } from './LeftMenuItem.style';
import { getEmptyObjectByType } from './LeftMenuItem.utils';

export const LeftMenuItem = memo(function LeftMenuItem({
    type,
    selected,
    setValueType,
    valueType,
    arrayPush,
    dirty,
    defaultValue,
}: {
    type: ResourceType | AirportConfigurationType;
    selected: boolean;
    valueType: ResourceType | AirportConfigurationType;
    setValueType: (valueType: ResourceType | AirportConfigurationType) => void;
    arrayPush: (obj: any) => void;
    dirty: boolean;
    defaultValue?: AirportConfiguration;
}) {
    const addNewValue = useCallback(() => {
        arrayPush(getEmptyObjectByType(valueType, defaultValue));
    }, [arrayPush, valueType, defaultValue]);

    return (
        <StyledMenuResourceItem
            container
            onClick={!dirty ? () => setValueType(type) : undefined}
            className={classNames({ selected, unavailable: dirty && !selected })}
        >
            <StyledPropertiesBox item xs>
                <FormattedMessage id={`form.value.type.${type}`} />
            </StyledPropertiesBox>

            <Grid width={'40px'} mr={'20px'}>
                <IconButton aria-label="delete" component="label" onClick={addNewValue} disabled={!selected}>
                    <StyledAddIcon />
                </IconButton>
            </Grid>
        </StyledMenuResourceItem>
    );
});
